module.exports = __webpack_public_path__ + "img/scale-03.d33d723f.svg";